import { useState } from 'react';

export const useSceneStepFlow = () => {
  const [isBottomSheetOpen, setIsBottomSheetOpen] = useState(false);

  const openBottomSheet = () => {
    setIsBottomSheetOpen(true);
  };

  const closeBottomSheet = () => {
    setIsBottomSheetOpen(false);
  };

  return {
    isBottomSheetOpen,
    openBottomSheet,
    closeBottomSheet
  };
};
